<div class="banner-area banner-img-one">
    <img src="https://mevoz.net/minjus/banner-prinsipal.jpg" class="img-fluid" style="width: 100%;"/>
</div>




<div class="portal-area pb-70">
    <div class="container">
        <div class="row align-items-center">
            
            <div class="col-lg-6">
                
            </div>
        </div>
    </div>
</div>

<section class="job-area pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Vakaturanan</h2>
        </div>


        <!-- Loading Spinner -->
        <div *ngIf="isLoadingJobs" class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div *ngIf="!isLoadingJobs" id="container">
            <div class="row">
                
                <div *ngFor="let job of featuredJobs" class="col-lg-6 mix web ui">
                    <div class="job-item">
                     
                        
            
                        <div class="job-inner align-items-center">
                            <div class="job-inner-left">
                                <h3>{{ job.title }}</h3>
                                <a >{{ job.companyName }}</a>
                                <ul>
                                    <li><i class="icofont-money-bag"></i>{{ job.salary }}</li>
                                    <li><i class="icofont-book"></i>{{ job.qualification }}</li>
                                </ul>
                            </div>
            
                            <div class="job-inner-right">
                                <div class="d-lg-block mb-2">
                                    <img [src]="job.logo" alt="Job" style="width: 120px;">
                                </div>
                              
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-lg sign-up-btn mt-4" style="background:#061f35; width:100%; border-radius: 0;" [routerLink]="['/job-details', job.id]">Mas informashon</button>
                    </div>
                </div>

            </div>
        </div>
        <button type="button" class="btn btn-primary btn-lg sign-up-btn mt-4" style="background:#061f35; width:100%; border-radius: 0;" [routerLink]="['/job-list']">Tur Vakatura..</button>
    </div>

    
</section>

<div class="counter-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-4 col-sm-4 col-lg-4">
                <div class="counter-item">
                    <i class="flaticon-curriculum"></i>
                    <h3><span class="counter">Varios</span></h3>
                    <p>Vakatura</p>
                </div>
            </div>

            <div class="col-4 col-sm-4 col-lg-4">
                <div class="counter-item">
                    <i class="flaticon-employee"></i>
                   
                    <h3><span class="counter">Varios</span></h3>
                    <p>Kupo di Trabou</p>
                </div>
            </div>

            <div class="col-4 col-sm-4 col-lg-4">
                <div class="counter-item">
                    <i class="flaticon-enterprise"></i>
                    <h3><span class="counter">15</span></h3>
                    <p>Organisashon</p>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="popular-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="popular-item">
                    <div class="row align-items-center">
                        <div class="col-lg-10">
                            <img src="assets/img/home-1/3.jpg" alt="Popular">
                        </div>

     
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="popular-item popular-right">
                    <div class="section-title text-start">
                        <h2>Ministerio di Hustisia di Kòrsou </h2> 
                    </div>
                   
                      
                       <p>
                       Nos ta e wesu di lomba di un komunidat safe, liber i hustu. Kaminda tur hende, independientemente di su estilo di bida òf kreensia, por biba den harmonia ku otro.
                        </p>
                        <p>
                            Den Hustisia nos ta aspirá pa krea un komunidat mas safe i hustu, no únikamente brindando protekshon, pero tambe, kaminda ta nesesario, guia pa medio di intervenshon. Nos akshonnan ta habri porta nobo i ta ofresé perspektiva nobo, ku e kapasidat úniko pa tuma desishonnan transendente. Pasobra lei ta toka nos tur. 
                        </p>
                 

      


                </div>
            </div>
        </div>
    </div>
</div>

<section class="companies-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Organisashonnan</h2>
        </div>

        <div>

           
            <swiper
            [slidesPerView]="4"
            [spaceBetween]="30"
            [loop]="true"
            [autoplay]="{ delay: 4000, disableOnInteraction: false }"
            [breakpoints]="swiperBreakpoints"
          >
            <ng-template swiperSlide *ngFor="let organization of organizations">
              <div class="companies-item" routerLink="/organization/{{organization.id}}">
                <img [src]="organization.logo" alt="uo-logo" class="responsive-img">
                <h4>{{ organization.name }}</h4>
              </div>
            </ng-template>
          </swiper>
          
          


        </div>
    </div>
</section>





